

import { useMemo, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

// Dashboard React components
import DSBox from "components/DSBox";
import DSAvatar from "components/DSAvatar";
import DSTypography from "components/DSTypography";

// Dashboard React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
const $ = require('jquery');
$.DataTable = require('datatables.net');
function Table({ columns, rows }) {
  const { light } = colors;
  const { size, fontWeightBold } = typography;
  const { borderWidth } = borders;
  const tableName = "table" + Math.floor(Math.random() * 11).toString();
  const renderColumns = columns.map(({ name, align }, key) => {
    let pl;
    let pr;

    if (key === 0) {
      pl = 3;
      pr = 3;
    } else if (key === columns.length - 1) {
      pl = 3;
      pr = 3;
    } else {
      pl = 1;
      pr = 1;
    }

    return (
      <DSBox
        key={name}
        component="th"
        pt={1.5}
        pb={1.25}
        pl={align === "left" ? pl : 3}
        pr={align === "right" ? pr : 3}
        textAlign={align}
        fontSize={size.xxs}
        fontWeight={fontWeightBold}
        color="secondary"
        opacity={0.7}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        {name.toUpperCase()}
      </DSBox>
    );
  });

  const renderRows = rows.map((row, key) => {
    const rowKey = `row-${key}`;

    const tableRow = columns.map(({ name, align }) => {
      let template;

      if (Array.isArray(row[name])) {
        template = (
          <DSBox key={row[name][1]} component="td" p={1}>
            <DSBox display="flex" alignItems="center" py={0.5} px={1}>
              <DSBox mr={2}>
                <DSAvatar src={row[name][0]} name={row[name][1]} variant="rounded" size="sm" />
              </DSBox>
              <DSTypography variant="button" fontWeight="medium" customClass="w-max">
                {row[name][1]}
              </DSTypography>
            </DSBox>
          </DSBox>
        );
      } else {
        template = (
          <DSBox key={row[name]} component="td" p={1} textAlign={align}>
            <DSTypography
              variant="button"
              fontWeight="regular"
              textColor="secondary"
              customClass="d-inline-block w-max"
            >
              {row[name]}
            </DSTypography>
          </DSBox>
        );
      }

      return template;
    });

    return <TableRow key={rowKey}>{tableRow}</TableRow>;
  });

  useEffect(() => {

    const table = $(`#${tableName}`).DataTable(
      {

      }
    )
    // Extra step to do extra clean-up.
    return function () {
      console.log("Table destroyed")
      table.destroy()
    }
  }, [])

  return useMemo(
    () => (
      <TableContainer>
        <MuiTable>
          <DSBox component="thead">
            <TableRow>{renderColumns}</TableRow>
          </DSBox>
          <TableBody>{renderRows}</TableBody>
        </MuiTable>
      </TableContainer>
    ),
    [columns, rows]
  );
}

// Setting default values for the props of Table
Table.defaultProps = {
  columns: [],
  rows: [{}],

};

// Typechecking props for the Table
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default Table;
